import { Suspense } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceOfferings from './components/ServiceOfferings';
import ProcessTimeline from './components/ProcessTimeline';
import ServicesCTA from './components/ServicesCTA';

export default function ServicesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": `${siteUrl}/services`,
        "name": "Bottleneck Audit & Strategic Advisory",
        "description": "Force Multiplier provides bottleneck audits and strategic advisory services to help founder-led companies identify and remove structural constraints limiting growth.",
        "provider": {
          "@type": "Organization",
          "name": "Force Multiplier",
          "url": siteUrl
        },
        "areaServed": "Worldwide",
        "url": `${siteUrl}/services`,
        "serviceType": "Strategic Advisory"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Services",
            "item": `${siteUrl}/services`
          }
        ]
      }
    ]
  };

  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <SEOHead
        title="Services | Force Multiplier"
        description="Bottleneck audits and strategic advisory services for founder-led companies. Identify and remove structural constraints limiting growth."
        canonicalPath="/services"
        schema={schema}
      />
      <div className="relative min-h-screen bg-black text-white overflow-hidden">
        <Navigation />
        <ServicesHero />
        <ServiceOfferings />
        <ProcessTimeline />
        <ServicesCTA />
        <Footer />
      </div>
    </Suspense>
  );
}